import React from "react";

import { observer } from "mobx-react";

export const MenuSportItemButtonCount = observer(
	function MenuSportItemButtonCount(props: {
		sportMenuItem: { node: { count: number } };
		isTopTournament?: boolean;
	}) {
		return (
			<span className="nav--secondary__counter counter counter--rounded counter--rounded--base counter--secondary counter--sup">
				{props.sportMenuItem.node.count}
			</span>
		);
	}
);
